import {TrackRemoveFromCartDto} from "@app/core/tracking/domain/dtos/track-remove-from-cart.dto";
import {TrackedItemMapper} from "@app/core/tracking/infrastructure/mappers/tracked-item.mapper";

export class TrackRemoveFromCartDtoMapper {
    static serialize(dto: TrackRemoveFromCartDto) {
        return {
            currency: dto.currency,
            value: dto.value,
            items: dto.items.map(item => TrackedItemMapper.serialize(item)),
        }
    }
}
